module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-213.d192ddd.woff2";